export default __webpack_public_path__ + "static/license-83d755bd405fbe51c87dc088baf26299.svg";